import { Outlet } from "react-router-dom";
import { NavLink } from "react-router-dom";
import styles from './MainLayout.module.css';
import Sidebar from '@shared/components/Sidebar/Sidebar';

function MainLayout({ appVersion }) {

  const getNavLinkClass = (styles) => {
    return ({ isActive }) =>
      isActive ? `${styles.sidebar_item} ${styles.active}` : styles.sidebar_item;
  };
  return (
    <div className={styles.app_container}>
        <Sidebar appVersion={appVersion}>
          <NavLink to="/" className={getNavLinkClass(styles)}>Home</NavLink>
          <NavLink to="/events" className={getNavLinkClass(styles)}>Events</NavLink>
          <NavLink to="/teams" className={getNavLinkClass(styles)}>Team Statistics</NavLink>
          <NavLink to="/logout" className={getNavLinkClass(styles)}>Logout</NavLink>
        </Sidebar>
     <div className={styles.main_content}>
      <Outlet />
     </div>
    </div>
  );
}

export default MainLayout;
